export default __webpack_public_path__ + "portfolio09.jpg";